(function () {
  "use strict";

  var SELECTOR = "[data-bb-consultation-widget]";
  var INITIALISED = "bbConsultationInitialised";
  var GLOBAL_MODE = "global-modal";
  var RESPONSIVE_SIDEBAR_MODE = "responsive-sidebar";
  var PDP_DESKTOP_QUERY = "(min-width: 1150px)";
  var activeModal = null;
  var globalModal = null;
  var delegatedTriggersBound = false;
  var scrollLock = null;

  function focusableElements(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll(
      "a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])"
    )).filter(function (element) {
      return !element.hidden && element.getAttribute("aria-hidden") !== "true";
    });
  }

  function lockPageScroll() {
    if (scrollLock) return;

    var root = document.documentElement;
    var body = document.body;
    var scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    scrollLock = {
      rootOverflow: root.style.overflow,
      overflow: body.style.overflow,
      paddingRight: body.style.paddingRight
    };
    root.style.overflow = "hidden";
    body.style.overflow = "hidden";
    if (scrollbarWidth) body.style.paddingRight = scrollbarWidth + "px";
    root.classList.add("bb-consultation-modal-open");
    body.classList.add("bb-consultation-modal-open");
  }

  function unlockPageScroll() {
    if (!scrollLock) return;

    var root = document.documentElement;
    var body = document.body;
    root.style.overflow = scrollLock.rootOverflow;
    body.style.overflow = scrollLock.overflow;
    body.style.paddingRight = scrollLock.paddingRight;
    root.classList.remove("bb-consultation-modal-open");
    body.classList.remove("bb-consultation-modal-open");
    scrollLock = null;
  }

  function readConfig(widget) {
    var configNode = widget.querySelector("[data-bb-consultation-config]");
    if (!configNode) return {};

    try {
      return JSON.parse(configNode.textContent);
    } catch (error) {
      console.warn("Biteback consultation config could not be parsed.", error);
      return {};
    }
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function isEligibleProduct(product) {
    return Boolean(product && product.available === true && product.status !== "ARCHIVED" &&
      product.title && product.url && product.variantId);
  }

  function productResolver(config) {
    var products = Object.assign({}, window.BitebackConsultationProducts || {}, config.products || {});

    return function resolveProduct(product) {
      return Object.assign({}, products[product.key] || {}, product);
    };
  }

  function normaliseConsultationData(data) {
    if (!data || !Array.isArray(data.journeys) || !data.journeys.length) {
      return null;
    }

    data.widgetDefaults = data.widgetDefaults || {};
    data.productCatalog = Array.isArray(data.productCatalog) ? data.productCatalog : [];
    data.journeys = data.journeys
      .filter(function (journey) {
        return journey && journey.key && journey.firstStepKey;
      })
      .map(function (journey) {
        journey.steps = Array.isArray(journey.steps) ? journey.steps : [];
        journey.recommendations = Array.isArray(journey.recommendations) ? journey.recommendations : [];
        return journey;
      });

    return data.journeys.length ? data : null;
  }

  function consultationPayload(instance, extra) {
    return Object.assign(
      {
        componentLocation: instance.location,
        presentationMode: instance.presentationMode || instance.mode,
        instanceId: instance.widget.id || null
      },
      extra || {}
    );
  }

  var HEADER_INITIAL = "initial";
  var HEADER_STEP = "step";
  var HEADER_RESULT = "result";

  var CONTEXT_LABEL_OVERRIDES = {
    "rubbing-scratching": "Rubbing and scratching behaviour"
  };

  var CHOICE_LABEL_OVERRIDES = {
    "skin-intact": "Skin is intact",
    "minor-wounds-abrasions": "Has rubbing led to minor wounds?",
    "pink-sun-sensitive": "Pink & sun-sensitive skin?",
    "thickened-dry-skin": "Thickened patches of dry skin?"
  };

  function ConsultationWidget(widget) {
    this.widget = widget;
    this.mount = widget.querySelector("[data-bb-consultation-mount]");
    this.config = readConfig(widget);
    this.mode = this.config.mode || widget.dataset.bbConsultationMode || "inline";
    this.presentationMode = this.mode;
    this.location = this.config.location || widget.dataset.bbConsultationLocation || "consultation";
    this.resolveProduct = productResolver(this.config);
    this.data = normaliseConsultationData(this.config.data);
    this.engine = this.createEngine();
    this.drawerOpen = false;
    this.drawer = null;
    this.opener = null;
    this.panelRendered = false;
    this.handleDrawerKeydown = this.onDrawerKeydown.bind(this);
    this.handleResponsiveChange = this.onResponsiveChange.bind(this);
  }

  ConsultationWidget.prototype.createEngine = function () {
    if (!window.BitebackConsultationEngine || !this.data) {
      return null;
    }

    return new window.BitebackConsultationEngine(this.data, {
      eventTarget: document,
      context: consultationPayload(this, { dataSource: this.config.dataSource || "shopify_metaobjects" })
    });
  };

  ConsultationWidget.prototype.render = function () {
    if (this.mode === RESPONSIVE_SIDEBAR_MODE) {
      if (!this.responsiveQuery) {
        this.responsiveQuery = window.matchMedia(PDP_DESKTOP_QUERY);
        this.responsiveQuery.addEventListener("change", this.handleResponsiveChange);
      }
      this.renderResponsivePresentation();
      return;
    }

    this.presentationMode = this.mode;
    if (this.mode === "modal" || this.mode === GLOBAL_MODE) {
      this.renderModalShell();
      return;
    }

    this.renderPanel(this.mount);
  };

  ConsultationWidget.prototype.onResponsiveChange = function () {
    if (this.drawerOpen) this.closeDrawer(false);
    this.renderResponsivePresentation();
  };

  ConsultationWidget.prototype.renderResponsivePresentation = function () {
    var desktop = this.responsiveQuery.matches;
    this.removePortalledDrawer();
    this.presentationMode = desktop ? "sidebar" : "modal";
    this.widget.dataset.bbConsultationPresentation = this.presentationMode;
    this.placeResponsiveWidget(desktop);
    this.mount.innerHTML = "";
    this.panelRendered = false;

    if (desktop) {
      this.renderPanel(this.mount);
    } else {
      this.renderModalShell();
    }
  };

  ConsultationWidget.prototype.removePortalledDrawer = function () {
    if (!this.drawer || this.drawer.parentNode !== document.body) return;
    this.drawer.removeEventListener("keydown", this.handleDrawerKeydown);
    this.drawer.remove();
    this.drawer = null;
  };

  ConsultationWidget.prototype.placeResponsiveWidget = function (desktop) {
    var root = this.widget.closest("product-info") || document;
    var container = this.widget.closest("[data-bb-consultation-responsive-container]") || this.widget;
    var slot = root.querySelector(desktop ? "[data-bb-consultation-desktop-slot]" : "[data-bb-consultation-mobile-slot]");
    if (slot && container.parentNode !== slot) slot.appendChild(container);
  };

  ConsultationWidget.prototype.renderModalShell = function () {
    var trigger = this.config.triggerless || this.mode === GLOBAL_MODE
      ? ""
      : '<button type="button" class="bb-consultation-trigger bb-consultation-trigger--card" data-bb-consultation-local-open>' +
        '<span class="bb-consultation-trigger__copy"><span class="bb-consultation-trigger__eyebrow">' + escapeHtml(this.config.mobileTriggerLabel || "Not sure where to start?") + '</span><span class="bb-consultation-trigger__detail">' + escapeHtml(this.config.mobileTriggerDetail || "Find the right solution") + "</span></span>" +
        '<svg class="bb-consultation-trigger__arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>' +
        "</button>";
    var drawerTitleId = escapeHtml((this.widget.id || "BitebackConsultation") + "-drawer-title");
    var responsiveDrawer = this.mode === RESPONSIVE_SIDEBAR_MODE;
    var drawerHeader = '<div class="bb-consultation-drawer__intro"><div class="bb-consultation-drawer__intro-copy"><h2 id="' + drawerTitleId + '" class="bb-consultation-drawer__title">Not sure this is the right product?</h2><p class="bb-consultation-drawer__copy">Answer a few quick questions and we\'ll point you to the best match.</p></div></div>';

    var drawerModifier = responsiveDrawer
      ? " bb-consultation-drawer--pdp"
      : this.mode === GLOBAL_MODE
        ? " bb-consultation-drawer--global"
        : " bb-consultation-drawer--modal";

    this.mount.innerHTML = trigger +
      '<div class="bb-consultation-drawer' + drawerModifier + '" data-bb-consultation-drawer data-bb-consultation-owner="' + escapeHtml(this.widget.id || "BitebackConsultation") + '" hidden>' +
      '<div class="bb-consultation-drawer__scrim" data-bb-consultation-close></div>' +
      '<div class="bb-consultation-drawer__panel" role="dialog" aria-modal="true" aria-labelledby="' + drawerTitleId + '" tabindex="-1">' +
      '<button type="button" class="bb-consultation-drawer__close" data-bb-consultation-close aria-label="Close consultation"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button>' +
      drawerHeader +
      '<div data-bb-consultation-panel></div>' +
      "</div></div>";

    var localTrigger = this.mount.querySelector("[data-bb-consultation-local-open]");
    this.drawer = this.mount.querySelector("[data-bb-consultation-drawer]");
    if (localTrigger) {
      localTrigger.addEventListener("click", function () {
        this.openDrawer(localTrigger);
      }.bind(this));
    }
    this.mount.querySelectorAll("[data-bb-consultation-close]").forEach(function (button) {
      button.addEventListener("click", function () {
        this.closeDrawer(true, true);
      }.bind(this));
    }, this);

    if (this.drawer) document.body.appendChild(this.drawer);

    if (this.mode === GLOBAL_MODE) globalModal = this;
  };

  ConsultationWidget.prototype.openDrawer = function (opener) {
    var drawer = this.drawer || this.mount.querySelector("[data-bb-consultation-drawer]");
    var panel = drawer ? drawer.querySelector("[data-bb-consultation-panel]") : null;

    if (!drawer || !panel) return;

    if (activeModal && activeModal !== this) activeModal.closeDrawer(false);

    this.opener = opener || document.activeElement;
    if (this.opener && this.opener.dataset && this.opener.dataset.bbConsultationLocation) {
      this.location = this.opener.dataset.bbConsultationLocation;
      if (this.engine) this.engine.eventContext.componentLocation = this.location;
    }

    this.drawerOpen = true;
    activeModal = this;
    drawer.hidden = false;
    if (!this.panelRendered) {
      this.renderPanel(panel);
      this.panelRendered = true;
    }
    drawer.addEventListener("keydown", this.handleDrawerKeydown);
    lockPageScroll();
    this.focusPanel(panel);
  };

  ConsultationWidget.prototype.renderPanel = function (scope) {
    scope.innerHTML = this.panelHtml();
    this.bindPanel(scope);
    this.restorePanelState(scope);
  };

  ConsultationWidget.prototype.restorePanelState = function (scope) {
    if (!this.engine || !this.engine.state || !this.engine.state.journeyKey) return;

    var result = this.engine.getResult();
    var step = this.engine.getCurrentStep();
    var stage = scope.querySelector("[data-bb-consultation-stage]");
    if (!stage) return;

    if (result) {
      this.setPanelHeader(scope, HEADER_RESULT);
      stage.innerHTML = this.resultHtml(result);
    } else if (step) {
      this.setPanelHeader(scope, HEADER_STEP);
      stage.innerHTML = this.stepHtml(step);
    }
    this.bindPanel(scope);
  };

  ConsultationWidget.prototype.closeDrawer = function (restoreFocus, explicitClose) {
    var drawer = this.drawer || this.mount.querySelector("[data-bb-consultation-drawer]");
    if (!drawer || !this.drawerOpen) return;

    this.drawerOpen = false;
    if (explicitClose && this.engine) this.engine.abandon("explicit_close");
    drawer.hidden = true;
    drawer.removeEventListener("keydown", this.handleDrawerKeydown);
    if (activeModal === this) activeModal = null;
    unlockPageScroll();

    if (restoreFocus !== false && this.opener && document.contains(this.opener)) {
      this.opener.focus({ preventScroll: true });
    }
  };

  ConsultationWidget.prototype.onDrawerKeydown = function (event) {
    if (event.key === "Escape") {
      event.preventDefault();
      this.closeDrawer(true, true);
      return;
    }

    if (event.key !== "Tab") return;

    var drawer = this.drawer || this.mount.querySelector("[data-bb-consultation-drawer]");
    var drawerPanel = drawer ? drawer.querySelector(".bb-consultation-drawer__panel") : null;
    var focusable = drawerPanel ? focusableElements(drawerPanel) : [];
    if (!focusable.length) {
      event.preventDefault();
      if (drawerPanel) drawerPanel.focus();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var currentIndex = focusable.indexOf(document.activeElement);
    if (event.shiftKey && (document.activeElement === first || currentIndex === -1)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || currentIndex === -1)) {
      event.preventDefault();
      first.focus();
    }
  };

  ConsultationWidget.prototype.panelHtml = function () {
    if (!this.engine) {
      return (
        '<div class="bb-consultation-panel">' +
        '<div class="bb-consultation-panel__header">' +
        '<p class="bb-consultation-panel__eyebrow">' + escapeHtml(this.config.eyebrow || "Product guide") + "</p>" +
        '<h2 id="' + escapeHtml((this.widget.id || "BitebackConsultation") + "-title") + '" class="bb-consultation-panel__title">' + escapeHtml(this.config.heading || "Find the right Biteback products") + "</h2>" +
        "</div>" +
        '<div class="bb-consultation-panel__body">' +
        this.unavailableHtml() +
        "</div>" +
        this.helpHtml() +
        "</div>"
      );
    }

    return (
      '<div class="bb-consultation-panel">' +
      '<div class="bb-consultation-panel__header">' +
      '<p class="bb-consultation-panel__eyebrow">' + escapeHtml(this.config.eyebrow || "Product guide") + "</p>" +
      '<h2 id="' + escapeHtml((this.widget.id || "BitebackConsultation") + "-title") + '" class="bb-consultation-panel__title" tabindex="-1">' + escapeHtml(this.config.heading || "Find the right Biteback products") + "</h2>" +
      "</div>" +
      '<div class="bb-consultation-panel__body" data-bb-consultation-stage>' + this.startHtml() + "</div>" +
      "</div>"
    );
  };

  ConsultationWidget.prototype.unavailableHtml = function () {
    return (
        '<div class="bb-consultation-unavailable">' +
        '<h3 class="bb-consultation-step__question">Product guide unavailable</h3>' +
        '<p class="bb-consultation-step__helper">We cannot load the consultation guide right now. Please contact us and we will help you choose.</p>' +
        "</div>"
    );
  };

  ConsultationWidget.prototype.eligibleProducts = function (result) {
    return (result && result.products || []).map(this.resolveProduct).filter(isEligibleProduct);
  };

  ConsultationWidget.prototype.panelHeader = function (state) {
    if (state === HEADER_RESULT) {
      return {
        eyebrow: "Guided consultation",
        title: "Your recommendation"
      };
    }

    if (state === HEADER_STEP) {
      return {
        eyebrow: "Guided consultation",
        title: "Tell us more"
      };
    }

    return {
      eyebrow: this.config.eyebrow || "Product guide",
      title: this.config.heading || "Find the right Biteback products"
    };
  };

  ConsultationWidget.prototype.setPanelHeader = function (scope, state) {
    var header = this.panelHeader(state);
    var eyebrow = scope.querySelector(".bb-consultation-panel__eyebrow");
    var title = scope.querySelector(".bb-consultation-panel__title");

    if (eyebrow) eyebrow.textContent = header.eyebrow;
    if (title) title.textContent = header.title;
  };

  ConsultationWidget.prototype.displayPrompt = function (step) {
    return step.prompt;
  };

  ConsultationWidget.prototype.displayChoiceLabel = function (choice) {
    return CHOICE_LABEL_OVERRIDES[choice.key] || choice.label;
  };

  ConsultationWidget.prototype.displayChoiceHelper = function (choice) {
    return choice.helperCopy || "";
  };

  ConsultationWidget.prototype.currentContextLabel = function () {
    if (!this.engine || !this.engine.state || !this.engine.state.pathway.length) return "";

    var previous = this.engine.state.pathway[this.engine.state.pathway.length - 1];
    if (!previous) return "";

    return CONTEXT_LABEL_OVERRIDES[previous.choiceKey] || CHOICE_LABEL_OVERRIDES[previous.choiceKey] || previous.choiceLabel || "";
  };

  ConsultationWidget.prototype.startHtml = function () {
    var journeys = this.engine.getJourneys();
    return (
      '<div class="bb-consultation-step">' +
      '<div class="bb-consultation-start__intro">' + (this.config.introHtml || "") + "</div>" +
      '<div class="bb-consultation-options">' +
      journeys.map(function (journey) {
        return (
          '<button type="button" class="bb-consultation-option" data-bb-consultation-start="' + escapeHtml(journey.key) + '">' +
          '<span class="bb-consultation-option__content">' +
          '<span class="bb-consultation-option__title">' + escapeHtml(journey.name) + "</span>" +
          (!this.config.compactInitial && journey.description ? '<span class="bb-consultation-option__text">' + escapeHtml(journey.description) + "</span>" : "") +
          "</span>" +
          "</button>"
        );
      }, this).join("") +
      "</div>" +
      this.disclaimerHtml() +
      "</div>"
    );
  };

  ConsultationWidget.prototype.stepHtml = function (step) {
    var self = this;
    var contextLabel = this.currentContextLabel();
    return (
      '<div class="bb-consultation-step">' +
      this.controlsHtml(true, false) +
      (contextLabel ? '<p class="bb-consultation-step__kicker">' + escapeHtml(contextLabel) + "</p>" : "") +
      '<h3 class="bb-consultation-step__question" tabindex="-1">' + escapeHtml(this.displayPrompt(step)) + "</h3>" +
      (step.helperCopy ? '<p class="bb-consultation-step__helper">' + escapeHtml(step.helperCopy) + "</p>" : "") +
      '<div class="bb-consultation-options">' +
      step.choices.map(function (choice) {
        var helper = self.displayChoiceHelper(choice);
        return (
          '<button type="button" class="bb-consultation-option" data-bb-consultation-choice="' + escapeHtml(choice.key) + '">' +
          '<span class="bb-consultation-option__content">' +
          '<span class="bb-consultation-option__title">' + escapeHtml(self.displayChoiceLabel(choice)) + "</span>" +
          (helper ? '<span class="bb-consultation-option__text">' + escapeHtml(helper) + "</span>" : "") +
          "</span>" +
          "</button>"
        );
      }, this).join("") +
      "</div>" +
      "</div>"
    );
  };

  ConsultationWidget.prototype.resultHtml = function (result) {
    var self = this;
    var products = this.eligibleProducts(result);
    if (!products.length) return this.controlsHtml(true, true) + this.unavailableHtml() + this.resultHelpHtml(result);
    var recommendationLabel = products.length > 1 ? "We recommend " + products.length + " products" : "We recommend";
    return (
      '<div class="bb-consultation-result bb-consultation-result--count-' + escapeHtml(products.length) + '">' +
      this.controlsHtml(true, true) +
      '<div class="bb-consultation-result__label" aria-hidden="true">' +
      '<span class="bb-consultation-result__check"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
      '<span>' + escapeHtml(recommendationLabel) + "</span>" +
      "</div>" +
      (result.recommendationCopy ? '<p class="bb-consultation-result__copy">' + escapeHtml(result.recommendationCopy) + "</p>" : "") +
      '<div class="bb-consultation-products">' +
      products.map(function (product) {
        return self.productHtml(self.resolveProduct(product));
      }).join("") +
      "</div>" +
      this.resultHelpHtml(result) +
      "</div>"
    );
  };

  ConsultationWidget.prototype.productHtml = function (product) {
    if (!isEligibleProduct(product)) return "";
    var imageAlt = product.imageAlt || product.title || "";
    var image = product.image
      ? '<img class="bb-consultation-product__image" src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(imageAlt) + '" loading="lazy">'
      : '<div class="bb-consultation-product__placeholder" aria-hidden="true"></div>';
    var price = product.price ? '<p class="bb-consultation-product__price">' + escapeHtml(product.price) + "</p>" : "";
    var productDescription = product.contextualCopy || product.description;
    var description = productDescription ? '<p class="bb-consultation-product__description">' + escapeHtml(productDescription) + "</p>" : "";
    var view = product.url
      ? '<a class="bb-button bb-button--primary" href="' + escapeHtml(product.url) + '" data-bb-consultation-product-link="' + escapeHtml(product.key) + '">View product</a>'
      : '<span class="bb-consultation-product__pending">Product details will appear once this guide is connected to Shopify products.</span>';
    var result = this.engine && this.engine.getResult();
    var pathwayKey = this.pathwayKey();
    var pathwayLabel = this.pathwayLabel();
    var form = product.variantId && product.available !== false
      ? '<form method="post" action="/cart/add" data-bb-consultation-product-form="' + escapeHtml(product.key) + '">' +
        '<input type="hidden" name="id" value="' + escapeHtml(product.variantId) + '">' +
        '<input type="hidden" name="quantity" value="1">' +
        '<input type="hidden" name="properties[_bb_consultation_attempt]" value="' + escapeHtml(this.engine.state.attemptId) + '">' +
        '<input type="hidden" name="properties[_bb_consultation_journey]" value="' + escapeHtml(this.engine.state.journeyKey) + '">' +
        '<input type="hidden" name="properties[_bb_consultation_pathway_key]" value="' + escapeHtml(pathwayKey) + '">' +
        '<input type="hidden" name="properties[_bb_consultation_pathway]" value="' + escapeHtml(pathwayLabel) + '">' +
        '<input type="hidden" name="properties[_bb_consultation_recommendation]" value="' + escapeHtml(result && result.recommendationKey) + '">' +
        '<input type="hidden" name="properties[_bb_consultation_relationship]" value="' + escapeHtml(product.relationshipKey) + '">' +
        '<input type="hidden" name="properties[_bb_consultation_product]" value="' + escapeHtml(product.shopifyProductReference || product.key) + '">' +
        '<button type="submit" class="bb-button bb-button--light">Add to cart</button>' +
        '<p class="bb-consultation-product__error" data-bb-consultation-product-error role="alert" hidden></p>' +
        "</form>"
      : '<span class="bb-consultation-product__pending">Currently unavailable</span>';

    return (
      '<article class="bb-consultation-product" data-bb-consultation-product="' + escapeHtml(product.key) + '">' +
      '<div class="bb-consultation-product__media">' +
      image +
      "</div>" +
      '<div class="bb-consultation-product__content">' +
      '<h4>' + escapeHtml(product.title || product.key) + "</h4>" +
      description +
      price +
      "</div>" +
      '<div class="bb-consultation-product__actions">' + view + form + "</div>" +
      "</article>"
    );
  };

  ConsultationWidget.prototype.pathwayKey = function () {
    if (!this.engine || !this.engine.state.journeyKey) return "";
    return [this.engine.state.journeyKey].concat(this.engine.state.pathway.map(function (answer) {
      return answer.choiceKey;
    })).join(">");
  };

  ConsultationWidget.prototype.pathwayLabel = function () {
    if (!this.engine || !this.engine.state.journeyKey) return "";
    var journey = this.engine.getJourney(this.engine.state.journeyKey);
    return [journey.name].concat(this.engine.state.pathway.map(function (answer) {
      return answer.choiceLabel;
    })).join(" → ");
  };

  ConsultationWidget.prototype.addToCart = function (form) {
    var self = this;
    var button = form.querySelector("[type='submit']");
    var product = this.resolveProduct({ key: form.dataset.bbConsultationProductForm });
    var cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    var errorMessage = form.querySelector("[data-bb-consultation-product-error]");
    var formData = new FormData(form);
    var eligible = this.eligibleProducts(this.engine && this.engine.getResult()).some(function (item) {
      return item.key === form.dataset.bbConsultationProductForm && String(item.variantId) === formData.get("id");
    });
    if (!eligible) return Promise.resolve();
    var config = typeof fetchConfig === "function" ? fetchConfig("javascript") : { method: "POST", headers: { Accept: "application/json" } };

    config.headers = config.headers || {};
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    if (cart && typeof cart.getSectionsToRender === "function") {
      formData.append("sections", cart.getSectionsToRender().map(function (section) { return section.id; }));
      formData.append("sections_url", window.location.pathname);
      if (typeof cart.setActiveElement === "function") cart.setActiveElement(document.activeElement);
    }

    config.body = formData;
    button.setAttribute("aria-disabled", "true");
    if (errorMessage) {
      errorMessage.hidden = true;
      errorMessage.textContent = "";
    }

    return fetch(window.routes && window.routes.cart_add_url || form.action, config)
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) throw new Error(response.description || response.message || "Unable to add this product to the cart.");

        if (!cart) {
          self.engine.recordAddToCart(Object.assign({}, product, {
            variantId: formData.get("id"),
            sellingPlanId: formData.get("selling_plan") || null,
            quantity: Number(formData.get("quantity") || 1),
            recommendationKey: self.engine.state.result && self.engine.state.result.recommendationKey
          }), consultationPayload(self, { confirmed: true }));
          window.location = window.routes && window.routes.cart_url || "/cart";
          return;
        }

        if (self.drawerOpen) {
          self.closeDrawer(false, false);
          if (self.opener && document.contains(self.opener) && typeof cart.setActiveElement === "function") {
            cart.setActiveElement(self.opener);
          }
        }

        if (typeof publish === "function" && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "biteback-consultation",
            productVariantId: formData.get("id"),
            cartData: response
          });
        }
        if (typeof cart.renderContents === "function") cart.renderContents(response);

        self.engine.recordAddToCart(Object.assign({}, product, {
          variantId: formData.get("id"),
          sellingPlanId: formData.get("selling_plan") || null,
          quantity: Number(formData.get("quantity") || 1),
          recommendationKey: self.engine.state.result && self.engine.state.result.recommendationKey
        }), consultationPayload(self, { confirmed: true }));
      })
      .catch(function (error) {
        console.error(error);
        if (errorMessage) {
          errorMessage.textContent = error.message || "Unable to add this product to the cart. Please try again.";
          errorMessage.hidden = false;
        }
      })
      .finally(function () {
        button.removeAttribute("aria-disabled");
      });
  };

  ConsultationWidget.prototype.controlsHtml = function (showBack, showRestart) {
    return (
      '<div class="bb-consultation-controls">' +
      (showBack ? '<button type="button" class="bb-consultation-control bb-consultation-control--back" data-bb-consultation-back><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 18 9 12l6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>' + escapeHtml(this.config.backLabel || "Back") + "</span></button>" : "") +
      (showRestart ? '<button type="button" class="bb-consultation-control bb-consultation-control--restart" data-bb-consultation-restart><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M3 4v5h5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Start over</span></button>' : "") +
      "</div>"
    );
  };

  ConsultationWidget.prototype.helpHtml = function () {
    if (!this.config.helpUrl) return "";
    return (
      '<div class="bb-consultation-help">' +
      '<a href="' + escapeHtml(this.config.helpUrl) + '" data-bb-consultation-help>' + escapeHtml(this.config.helpLabel || "Ask us for help choosing") + "</a>" +
      "</div>"
    );
  };

  ConsultationWidget.prototype.disclaimerHtml = function () {
    var disclaimer = this.config.disclaimerHtml || "<p>This is product-discovery guidance, not professional animal-health advice.</p>";
    if (!disclaimer) return "";
    if (this.config.compactInitial) return "";

    return '<div class="bb-consultation-disclaimer">' + disclaimer + "</div>";
  };

  ConsultationWidget.prototype.resultHelpHtml = function (result) {
    if (!this.config.helpUrl) return "";
    var helpCopy = result && result.humanHelpCopy ? result.humanHelpCopy : "Still not sure, or need advice?";
    return (
      '<div class="bb-consultation-result-help">' +
      '<p>' + escapeHtml(helpCopy) + '</p>' +
      '<a href="' + escapeHtml(this.config.helpUrl) + '" data-bb-consultation-help><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12a8 8 0 0 1 16 0v4a2 2 0 0 1-2 2h-2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M6 13v-2a2 2 0 0 1 2-2h1v6H8a2 2 0 0 1-2-2Zm12 0v-2a2 2 0 0 0-2-2h-1v6h1a2 2 0 0 0 2-2Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg><span>Talk to a real person</span></a>' +
      "</div>"
    );
  };

  ConsultationWidget.prototype.bindPanel = function (scope) {
    scope.querySelectorAll("[data-bb-consultation-start]").forEach(function (button) {
      button.addEventListener("click", function () {
        var step = this.engine.start(button.dataset.bbConsultationStart);
        this.renderStage(scope, this.stepHtml(step), HEADER_STEP);
      }.bind(this));
    }, this);

    scope.querySelectorAll("[data-bb-consultation-choice]").forEach(function (button) {
      button.addEventListener("click", function () {
        this.engine.selectChoice(button.dataset.bbConsultationChoice);
        var result = this.engine.getResult();
        this.renderStage(scope, result ? this.resultHtml(result) : this.stepHtml(this.engine.getCurrentStep()), result ? HEADER_RESULT : HEADER_STEP);
      }.bind(this));
    }, this);

    scope.querySelectorAll("[data-bb-consultation-back]").forEach(function (button) {
      button.addEventListener("click", function () {
        var step = this.engine.back();
        this.renderStage(scope, step ? this.stepHtml(step) : this.startHtml(), step ? HEADER_STEP : HEADER_INITIAL);
      }.bind(this));
    }, this);

    scope.querySelectorAll("[data-bb-consultation-restart]").forEach(function (button) {
      button.addEventListener("click", function () {
        this.engine.reset("start_over");
        this.renderStage(scope, this.startHtml(), HEADER_INITIAL);
      }.bind(this));
    }, this);

    scope.querySelectorAll("[data-bb-consultation-product-link]").forEach(function (link) {
      link.addEventListener("click", function () {
        this.engine.recordProductClicked(this.resolveProduct({ key: link.dataset.bbConsultationProductLink }), consultationPayload(this));
      }.bind(this));
    }, this);

    scope.querySelectorAll("[data-bb-consultation-product-form]").forEach(function (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        if (form.querySelector("[type='submit']").getAttribute("aria-disabled") === "true") return;
        this.addToCart(form);
      }.bind(this));
    }, this);
  };

  ConsultationWidget.prototype.renderStage = function (scope, html, headerState) {
    var stage = scope.querySelector("[data-bb-consultation-stage]");
    if (!stage) return;

    this.setPanelHeader(scope, headerState || HEADER_INITIAL);
    stage.innerHTML = html;
    this.bindPanel(scope);
    this.focusPanel(scope);
  };

  ConsultationWidget.prototype.focusPanel = function (scope) {
    var focusTarget = scope.querySelector("[tabindex='-1']") || scope.querySelector("button, a");
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  };

  function init() {
    if (!window.BitebackConsultationEngine) return;

    document.querySelectorAll(SELECTOR).forEach(function (widget) {
      if (widget.dataset[INITIALISED]) return;
      widget.dataset[INITIALISED] = "true";
      new ConsultationWidget(widget).render();
    });

    bindDelegatedTriggers();
  }

  function bindDelegatedTriggers() {
    if (delegatedTriggersBound) return;
    delegatedTriggersBound = true;

    document.addEventListener("click", function (event) {
      var trigger = event.target.closest && event.target.closest("[data-bb-consultation-open]");
      if (!trigger || trigger.closest(SELECTOR) || !globalModal) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      event.preventDefault();
      globalModal.openDrawer(trigger);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
